/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CartNav_item = {|
  +pdpURL: ?string;
  +serviceId: ?string;
  +title: ?string;
  +isSold: ?boolean;
  +photos: ?$ReadOnlyArray<?{|
    +versions: ?$ReadOnlyArray<?{|
      +webPath: ?string;
      +type: ?{|
        +name: ?"thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master" | "placeholder";
      |};
    |}>;
  |}>;
  +pricing: ?{|
    +netPrice: ?{|
      +amount: ?number;
      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
        +amount: ?number;
      |}>;
    |};
    +salePrice: ?{|
      +amount: ?number;
      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
        +amount: ?number;
      |}>;
    |};
    +retailPrice: ?{|
      +amount: ?number;
      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
        +amount: ?number;
      |}>;
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_item",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "title",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isSold",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "webPath",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ImageVersionType",
              "name": "type",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemPricing",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "name": "netPrice",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "amount",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmountList",
              "name": "convertedAmountList",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "currency",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "name": "salePrice",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "amount",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmountList",
              "name": "convertedAmountList",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "currency",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "name": "retailPrice",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "amount",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmountList",
              "name": "convertedAmountList",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "currency",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "amount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
